import { gql } from '@apollo/client';

export default gql`
  mutation createMultiCategories($data: String) {
    createMultiCategories(data: $data) {
      ok
      message
      error
    }
  }
`;
